import { IndexedDb } from '@edonec/indexed-db-class';
import axios from 'axios';
import { refreshUserToken } from 'client/_redux/actions/auth';

export const CLIENT_API =
  process.env.NODE_ENV === 'production'
    ? `${process.env.RAZZLE_HOST}${process.env.RAZZLE_API_PREFIX}`
    : `http://localhost:3000${process.env.RAZZLE_API_PREFIX}`;
export const API =
  process.env.NODE_ENV === 'production'
    ? `${process.env.RAZZLE_HOST}`
    : `http://localhost:3000`;
export const clientApi = axios.create({
  baseURL: CLIENT_API,
});

export const resetAuthToken = async (token?: string) => {
  if (token) {
    clientApi.defaults.headers.Authorization = `bearer ${token}`;
  } else {
    clientApi.defaults.headers.Authorization = '';
  }
};

// eslint-disable-next-line import/no-mutable-exports
let db: IndexedDb;

if (typeof window !== 'undefined') {
  db = new IndexedDb('Auth', [{ tableName: 'user', key: 'id' }]);
}

export { db };

clientApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const request = error.config;

    if (
      error.response?.status === 403 &&
      error.response.data === 'Token expired' &&
      !request._retry
    ) {
      request._retry = true;
      await refreshUserToken();
      request.headers.Authorization = clientApi.defaults.headers.Authorization || '';

      return clientApi(request);
    }

    return Promise.reject(error);
  },
);
